import React from "react";
// import "./InstituteManagement.css"; // custom styles

const ProductDes = (props) => {
    return (
        <div className="container text-center py-5">
            <h2 className="fw-bold mb-2">
                {props.largeHeading}
            </h2>
            <div className="mx-auto mb-4" style={{
                width: '60px',
                height: '4px',
                backgroundColor: '#3bc9f5',
                borderRadius: '2px'
            }}></div>

            <p className="text-muted mx-auto w-75">
               {props.para1}
            </p>

            <p className="text-muted mx-auto w-75 mt-4">
               {props.para2}
            </p>
            <p className="text-muted mx-auto w-75 mt-4">
               {props.para3}
            </p>
        </div >
    );
};

export default ProductDes;
